<template>
  <div>
    <div v-if="isAuthenticated">
      <AppHeader/>

      <section class="forgot-password-sc navbar-space no-padding">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-8 col-sm-12 col-xl-7 col-xs-fix">
              <div class="personal-info-wrapper mb-5" id="accordion">
                <form @submit.prevent="changePassword">
                  <div class="card card-form">
                    <!-- Toggle Disable for card-expandable -->
                    <div
                      class="card-header"
                      id="headingTwo"
                      data-toggle="collapse"
                      data-target="#collapseTwo"
                      aria-expanded="true"
                      aria-controls="collapseTwo"
                    >
                      <div class="title">
                        <i class="feather-icon icon-lock"></i>
                        <h5 class="mb-0">ตั้งรหัสผ่านใหม่</h5>
                      </div>
                      <i class="feather-icon icon-chevron-left"></i>
                    </div>
                    <div id="collapseTwo" aria-labelledby="headingTwo" data-parent="#accordion">
                      <div class="card-body compact-padding">
                        <div class="default-padding">
                          <div class="form-group mb-2">
                            <label>ตั้งรหัสผ่านใหม่</label>
                            <div class="pass-form-wrapper">
                              <vue-password
                                v-model="oldpassword"
                                name="oldpassword"
                                classes="form-control"
                                v-validate="{ required:true,min:8,max:20}"
                                data-vv-as="รหัสผ่านเดิม"
                                placeholder="รหัสผ่านเดิม"
                                disableStrength
                                :class="{'input': true, 'is-danger': errors.has('oldpassword') }"
                              ></vue-password>
                              <span
                                v-show="errors.has('oldpassword')"
                                class="help is-danger"
                              >{{ errors.first('oldpassword') }}</span>
                            </div>
                          </div>
                          <div class="form-group mb-4">
                            <div class="pass-form-wrapper">
                              <vue-password
                                v-model="password"
                                name="password"
                                classes="form-control"
                                v-validate="{ required:true,min:8,max:20, regex:/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])([a-zA-Z0-9]{8,20})$/,}"
                                data-vv-as="รหัสผ่านใหม่"
                                placeholder="รหัสผ่านใหม่"
                                :class="{'input': true, 'is-danger': errors.has('password') }"
                                disableStrength
                              ></vue-password>
                              <!-- /^(?=.*[A-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+])\S{8,}$/ -->
                              <span
                                v-show="errors.has('password')"
                                class="help is-danger"
                              >{{ errors.first('password') }}</span>

                              <div class="pass-form-wrapper">
                              <vue-password
                                v-model="confirmpassword"
                                name="confirmpassword"
                                classes="form-control"
                                placeholder="ยืนยันรหัสผ่าน"
                                data-vv-as="ยืนยันรหัสผ่าน"
                                v-validate="{ required:true,confirmed:password}"
                                :class="{'input': true, 'is-danger': errors.has('confirmpassword') }"
                                disableStrength
                              ></vue-password>
                              <span
                                v-show="errors.has('confirmpassword')"
                                class="help is-danger"
                              >{{ errors.first('confirmpassword') }}</span>
                            </div>
                            </div>
                          </div>

                          <div class="form-group mb-4">
                            <div class="form-text">
                              <li>ความยาวของรหัสผ่านต้องไม่น้อยกว่า "8-20" ตัวอักษร</li>
                              <!-- <li>ต้องประกอบด้วยอักขระพิเศษอย่างน้อย "1"</li> -->
                              <li>ตัวอักษรต้องประกอบด้วยตัวเล็กและตัวใหญ่</li>
                              <li>ต้องประกอบด้วยตัวเลขอย่างน้อย "1"</li>
                            </div>
                          </div>
                          <div class="row justify-content-center mt-3">
                            <div class="col-sm-7 col-lg-7 col-xl-7">
                              <div class="cta-btn single-btn mb-0">
                                <button type="submit" class="btn btn-info btn-round btn-block shadow-sm">ยืนยัน</button>
                              </div>
                            </div>
                          </div>
                          <div class="row justify-content-center mt-3">
                            <div class="col-sm-7 col-lg-7 col-xl-7"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <AppFooter/>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import AppFooter from "../pagecomp/appFooter";
import AppHeader from "../pagecomp/appHeader";
import { AUTH_LOGOUT,AUTH_SUCCESS,AUTH_REQUEST } from "@/store/actions/auth";
import { USER_REQUEST } from '@/store/actions/user'
import { mapGetters } from "vuex";
import axios from "axios";
import Loading from "@/components/lib/loading";
import { apiClient } from "@/utils/apiClient";
import VuePassword from "vue-password";

export default {
  name: "changePassword",
  components: {
    AppFooter,
    AppHeader,
    VuePassword
  },
  data() {
    return {
      username: "",
      oldpassword: "",
      password: "",
      confirmpassword: ""
    };
  },
  computed: {
    ...mapGetters(["isAuthenticated", "authStatus"])
  },
  methods: {
    test: function() {
      alert(this.$store.getters.token);
    },

    changePassword: function() {
      const { username, password } = this;

      this.$validator.validateAll().then(result => {
        if (!result) {
          return;
        } else {

          this.loader = this.$loading.show();
          apiClient
            .post("/api/auth/changePassword", {
              password: this.oldpassword,
              newPassword: this.password,
              confirmPassword: this.confirmpassword
            })
            .then(response => {
              if (response.data.status === "S") {

                let tmpResponse = {
                  data: { accessToken: this.$store.getters.token }
                };
                this.$store.commit(AUTH_SUCCESS, tmpResponse);
                this.$store.dispatch(USER_REQUEST);
                this.$router.push("/disclaimer");

                this.$swal("", "เปลี่ยนรหัสผ่านเรียบร้อย", "success");

              } else {

                this.$swal("","ไม่สามารถเปลี่ยนรหัสผ่านได้ : </br>" + response.data.message, "error" );
              }
              this.loader.hide();
            })
            .catch(err => {

              this.loader.hide();
              this.$swal("", "ไม่สามารถเปลี่ยนรหัสผ่านได้ ="+err, "error");
            });
        }
      });
    }
  }
};
</script>
<style>
.VuePassword__Message {
  font-size: 0.8rem !important;
}
</style>
